import React from 'react'
import { Provider as ParentProvider } from '../Context'
import { Layout } from './Layout'

export const Preview = () => {
  return (
    <ParentProvider>
      <Layout />
    </ParentProvider>
  )
}
